'use strict';

function makeAnimationInstant(options) {
    options.duration = 0;
    options.type === "keyframes";
}

exports.makeAnimationInstant = makeAnimationInstant;
//# sourceMappingURL=make-animation-instant.cjs.map
